(function() {
  'use strict';

  function SlotController($scope, $translate, UserFields, USER_STATES) {
    var ctrl = this;

    var updateState = function(action) {
      $scope.item.updateState(action)
        .then(function() {
          $scope.options.loadList();
        });
    };

    ctrl.STATES = USER_STATES;

    // get all user fields
    UserFields.findFeatured()
      .then(function(featuredUserFields) {
        ctrl.featuredUserFields = featuredUserFields;
      });

    ctrl.actionButtons = $scope.item.actionButtons();
    ctrl.secondaryActionButtons = $scope.item.secondaryActionButtons().concat([
      {
        label: $translate.instant('Disable'),
        icon: 'icon-toggle-off',
        onClick: updateState.bind(this, 'user_disable'),
        showCondition: function() {
          if ($scope.item.isDisabled($scope.item)) {
            return false;
          }
          return $scope.item.canReview();
        },
        klass: 'text-danger'
      },
      {
        label: $translate.instant('Enable'),
        icon: 'icon-toggle-on',
        onClick: updateState.bind(this, 'user_enable'),
        showCondition: function() {
          if (!$scope.item.isDisabled) {
            return false;
          }
          return $scope.item.canReview();
        },
        klass: 'text-success'
      }
    ]);
  }

  SlotController.$inject = [
    '$scope',
    '$translate',
    'UserFieldsService',
    'USER_STATES'


  ];

  function SlotDirective() {
    return {
      scope: {
        item: '=',
        options: '='
      },
      restrict: 'AE',
      templateUrl: 'app/components/users/user.slot.html',
      controller: SlotController,
      controllerAs: 'ctrl'
    };
  }

  angular.module('component.users')
    .directive('userSlot', SlotDirective)
    .controller('UserSlotController', SlotController);
})();
